import { Component, OnInit } from '@angular/core';
import { Subscription, Subject, Observable } from 'rxjs/';

import { RxComponent } from 'app/core/components/common/rx.component';
import { ActionClickEvent, BulkActionClickEvent } from 'app/shared/components/dynamic-grid/dynamic-grid.component';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';
import { MiddlemanService } from 'app/core/services/middleman.service';
import { ProductsService } from './products.service';

import { SmartModalService } from 'app/core/services/smart-modal.service';
import { ProductBulkEditComponent } from './bulk-edit/product-bulk-edit.component';

@Component({
  selector: 'itpx-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent extends RxComponent implements OnInit {

    private url: string;
    private detailsRoute: string = '/agora/product-data/products/{{key}}/details';
    private bulkActionsConfig: any;
    
    private gridRefresh = new Subject<any>();
    private gridClearSelection = new Subject<any>();
    private actionClicked = new Subject<ActionClickEvent>();
    private bulkActionClicked = new Subject<BulkActionClickEvent>();

    private fields: Array<any> = [
        {
            title: 'SKU',
            name: 'sku',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            },
            sortable: true
        }, {
            title: 'Name',
            name: 'name',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            },
            sortable: true
        }, {
            title: 'List Price',
            name: 'pricing.listPrice'
        }, {
            title: 'Online',
            name: 'online',
            config: {
                type: 'map',
                map: {
                    'true': 'Yes',
                    'false': 'No'
                }
            }
        }, {
            title: 'Available',
            name: 'available',
            config: {
                type: 'map',
                map: {
                    'true': 'Yes',
                    'false': 'No'
                }
            }
        }, {
            title: 'Product Type',
            name: 'type.configValue'
        }, {
            title: 'ByD ID',
            name: 'systemInfo.bydId',
            hidden: true
        }
    ];

    constructor(
        private configService: ConfigService,
        private service: ProductsService,
        private middlemanService: MiddlemanService,
        private modalService: SmartModalService
    ) {
        super();
        this.url = configService.get('server').url + configService.get('endpoints').agora.products.list.api;
        this.bulkActionsConfig = this.service.getBulkActions();
    }

    ngOnInit() {
        this.bulkActionClicked
            .filter(e => e.action === 'edit')
            .bindToLifecycle(this)
            .subscribe(e => this.redirectForBulkUpdate(e.items))
    }

    private onBulkActionClicked(e: BulkActionClickEvent) {
        this.bulkActionClicked.next(e);
    }

    private redirectForBulkUpdate(items: any[]) {
        let ids = items.map(_ => new Object({id: _.id}));

        this.middlemanService.navigate('/agora/product-data/products/bulk-edit', ids);
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/products/products.component.ts